/// <amd-module name="VSSUI/Components/Dialog/Dialog" />
import * as React from "react";

import { IDialogProps } from "VSSUI/Components/Dialog/Dialog.Props";
import { DialogInternal } from "./DialogInternal";

export class Dialog extends React.Component<IDialogProps> {
    public render(): JSX.Element {
        return <DialogInternal {...this.props} modal={true} />;
    }
}
